<!-- Swipe main -->
<template>
  <div class="swiper-container">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="(order) in orders" :key="order.id">
        <SwiperCherk :order="order" :orders="orders" :paymentType="paymentType" :uuidGets="uuidGets"
          :isActiveReviews="isActiveReviews" :onRefresh="onRefresh">

        </SwiperCherk>
      </div>
    </div>
    <!-- Пагинация -->
    <div class="swiper-pagination"></div>
    <!-- Вхід в оферту закладу — тут, а не біля кнопки: рядок «Продовжуючи…»
         поруч із кнопкою веде в договір платника платіжки, це інший документ. -->
    <div class="footerContainer footerSwiper">
      <TermsLinks />
      <span>
        Powered by <a target="_blank" href="https://skyservice.pro">Skyservice POS</a>
      </span>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';

import { Pagination } from 'swiper/modules';
import SwiperCherk from './SwiperCherk.vue';
import TermsLinks from '@/components/TermsLinks.vue';

export default {
  props: ['orders', 'paymentType', 'uuidGets', 'isActiveReviews','onRefresh'],
  data() {
    return {
      statusH: window.innerHeight - 95,
      swiper: null,
    };
  },
  mounted() {

    this.swiper = new Swiper('.swiper-container', {
      modules: [Pagination],
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      // Це все для оптимізації для старих телефонів, хз чи допоможе
      virtual: true, // Оптимізує рендеринг
      lazy: true, // Ліниве завантаження зображень
      speed: 400,
      allowTouchMove: true,

    });

    window.addEventListener('resize', this.updateHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateHeight);
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
  },
  components: {
    SwiperCherk,
    TermsLinks
  },
  methods: {
    updateHeight() {
      this.statusH = window.innerHeight - 95//95;
    },
  },
  updated() {
    this.swiper && this.swiper.update();
  },
  computed: {

  },
};
</script>

<style scoped>
.swiper-container {
  width: 100%;
  height: 100%;
  background: var(--innerBody) !important;
  position: relative;
}

.swiper-pagination {
  bottom: 10px;
  /* Нижнее положение */
  text-align: center;
  width: 100%;

  /* position: fixed; */
  position: absolute;
  bottom: 105px;
  left: 0;
  display: flex;
  justify-content: center;



}

#app-slider {
  height: 100%;
}





/* Смуга стала дворядковою (умови + «Powered by»), тож жорсткі 20px із
   глобального .footerContainer тут перебиваємо. Висота .cont-bottom у
   SwiperCherk врахована під це, інакше смуга наїжджає на кнопку оплати. */
.footerSwiper {
  height: auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* 4px — як у футері StartPage.vue: між рядками футера скрізь один відступ. */
  gap: 4px;
  padding-top: 4px;
  position: fixed;
  /* bottom: 5px; */
  bottom: 0;
  left: 0;
  padding-bottom: 5px;
  z-index: 999;
  border-color: var(--footer) !important;
  color: var(--text-footer) !important;
  /* background-color: rgb(41, 41, 41, 1); */
  background: var(--footer) !important;

}


.footerContainer > span a {
  color: var(--text-footer) !important;

}

/* TermsLinks за замовчуванням фарбується --text-head — під футер стартової
   сторінки, де сусідній «Powered by» саме цього кольору. Тут фон інший
   (--footer), тож рівняємось на сусіда цієї смуги. */
.footerSwiper ::v-deep .terms-links__item {
  color: var(--text-footer) !important;
}


</style>